<template>
    <div>
        <template v-if="getExtras().length">
            <div class="overview-title" style="margin-top: 0px; display: flex; padding: 8px 16px; box-shadow: inset 0 8px 15px rgba(0,0,0,.03);">
                <span class="overview--sub-title roboto f16 bold--text">{{ $t('plan_calculator.extras') }}</span>
                <div style="flex-grow: 1" />
                <pm-price class="black--text roboto bold--text f16 pm-price" :currency="$store.state.currency" :value="fullTotal" />
            </div>

            <div class="pm-smart-treatment-overview-item white pa20" style="box-shadow: 0 8px 15px rgba(0,0,0,.03); border-top: 1px dotted #dfe0e2!important;">
                <div style="display: flex;">
                    <div class="pm-plan-summary-extras-icon">
                        <v-icon style="transition: all .3s; margin: 0 0 0 0;" class="black--text" :style="jaw==='upper' ? 'transform: rotate(0deg)' : 'transform: rotate(180deg)'">
                            plus_circle_outline
                        </v-icon><br>
                    </div>
                    <div style="margin: 0 14px; width: 2px; background: #DBDCDE;" />
                    <div style="flex-grow: 1;">
                        <div v-for="(option, key) in getExtras()"
                             v-if="option.amount > 0"
                             style="padding: 4px 0 4px 0; display: flex; justify-content: center; align-items: center;"
                             :style="key > 0 ? 'border-top: 1px dotted #eee;' : ''"
                        >
                            <template v-if="option.isPercentage">
                                <div class="f12" style="color: #7B8088; flex-grow: 1;">
                                    {{ getTitle(option) }} (+{{ option.amount }}%)
                                </div>
                                <div>
                                    <pm-price style="color: #7B8088;" class="roboto f12 black--text" :value="Math.round(($store.state.simplePlan.upperJawTotal + $store.state.simplePlan.lowerJawTotal) * (option.amount / 100))" />
                                </div>
                            </template>

                            <template v-else>
                                <div class="pm-plan-summary-extras-item">
                                    <span v-if="!option.isPercentage">{{ option.amount }}</span> {{ getTitle(option) }}
                                </div>
                                <div>
                                    <pm-price class="roboto pm-plan-summary-extras-item-price black--text" :value="option.unit_price * option.amount" />
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<style>
    .pm-plan-summary-extras-icon {
        text-align: center;
        justify-self: center;
        align-self: center;
        width: 44px;
    }
    .pm-plan-summary-extras-item {
        font-size: 12px;
        color: #7B8088;
        flex-grow: 1;
    }
    .pm-plan-summary-extras-item-price {
        font-size: 12px;
    }
    .pm-smart-treatment-overview-item {
        position: relative;
    }

    @media (min-width: 700px) {
        .pm-plan-summary-extras-icon {
            text-align: left;
        }

        .pm-plan-summary-extras-item,
        .pm-plan-summary-extras-item-price {
            font-size: 18px;
        }
    }
</style>

<script>


export default {
    props: {
        jaw: {
            type: String,
            default: "upper",
        },
    },
    computed: {
        fullTotal() {
            let extraValue = 0;

            this.$store.state.simplePlan.extraSteps.forEach((step) => {
                if (step.isPercentage && step.amount > 0) {
                    extraValue = Math.round((this.$store.state.simplePlan.upperJawTotal + this.$store.state.simplePlan.lowerJawTotal) * (step.amount / 100));
                }
            });

            return extraValue + this.$store.state.simplePlan.extraTotal;
        },
    },
    methods: {
        getExtras() {
            return this.$store.state.simplePlan.extraSteps.filter((item) => {
                if (item.isPercentage && this.$store.state.simplePlan.upperJawTotal + this.$store.state.simplePlan.lowerJawTotal == 0) return false;
                return parseInt(item.amount) > 0;
            });
        },
        getTitle(step) {
            if (typeof step.state_id !== 'undefined') {
                let title = this.$store.getters["smart/titleOfTreatment"](step.state_id, this.$store.state.language, false);
                try {
                    let pid = this.$store.state.localSettings.dentalStates[String(step.state_id)].parent_id;
                    if (this.$te('plan_calculator.option_' + pid)) return this.$t('plan_calculator.option_' + pid) + " - " + title;
                    return title;
                } catch(error) {
                    captureException(error);
                    return title;
                }
            }
            if (step.isGroup && typeof step.groupId !== 'undefined') return this.$t("plan_calculator.group_" + step.groupId);
            if (step.isPercentage) return this.$t("extra_treatments.other");
            return step.title;
        },
    },
};
</script>
